import React from 'react';
import DownloadPage from './DownloadPage';
import { generateComponentDocs, generateStoryDocs } from '../../utils/documentationUtils';

export default {
  title: 'Pages/DownloadPage',
  component: DownloadPage,
  parameters: {
    layout: 'fullscreen',
    ...generateComponentDocs(
      // 1. What problem does it solve?
      `After all users successfully confirm their new account, users land on the sign-in page but are unable to log in since they don’t have permission to access the web app. DownloadPage allows all user types to download the mobile app. This page directs users to download the mobile app.
        \n\n####_***It allows users to:***_
        \n Download Vamos app even if they can't access the web app after they create their accounts.\n\n`,

      // 2) When & how to use it?
      '\nCurrently, append /download to the base URL. For example, localhost:3000/download',

      // 3) Current Usage
      `
- If the user is signed in, they see the page header with organization and user info on the upper right.
- If not, there's no organization or user info on the upper right.
      
** Key Points **
  - **Organization & User Info**: Depends on the user's sign-in status; this information is conditionally displayed.
  - **Navigation Bar**: The navigation bar will not be shown on the download page.`,

      // 4) Related Components
      `\n- **PageHeaderWrapper**: Provides the page header with conditionally rendered organization and user info.
        \n- **PageFooter**: Displays the footer information.\n\n`,
    ),
  },
  tags: ['autodocs'],
};

const Template = () => <DownloadPage />;

export const Download = Template.bind({});

Download.parameters = generateStoryDocs(
  // When is this variant used?
  '\nIt provides two links to download the Vamos mobile app.',
  // Where is it currently used in the product?
  '\nUsers can navigate to this page by appending /download to base url. For example, localhost:3000/download',
);
